import { CatalogListItem } from '@shared/model/catalog';
import { useMemo } from 'react';

export const useNormalizeInitialValues = (values?: CatalogListItem) => {
    const initialValues = useMemo(() => {
        if (!values) {
            return {
                active: true,
                sort: 100,
                products: [],
                companies: [],
            };
        }

        return {
            ...values,
            products:
                values.products?.map((product) => ({
                    label: product.name,
                    value: String(product.id),
                })) || [],
            companies:
                values.companies?.map((company) => ({
                    label: company.shortName,
                    value: String(company.id),
                })) || [],
        };
    }, [values]);
    return initialValues;
};
